(function () {
  if (window.__moxTallaInitV9) return;
  window.__moxTallaInitV9 = true;

  // === FLAG GLOBAL DEL ARCHIVO (hoisted) =========
  const ADDITIVE_INPUT_MODE = (typeof window.MOX_ADDITIVE_INPUT_MODE === 'boolean')
    ? window.MOX_ADDITIVE_INPUT_MODE
    : true; // <- true = siempre sumar lo digitado
  window.MOX_ADDITIVE_INPUT_MODE = ADDITIVE_INPUT_MODE;

  // ===================== Utils =====================
  const fmtCOP = new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 });
  const SUBTRACT_DRAFT_ON_COLOR_CHANGE = true;

  function toInt(v, def = 0) { const n = Number(String(v).replace(/[^\d.-]/g, '')); return Number.isFinite(n) ? n : def; }
  function toNum(v, def = 0) { const n = Number(v); return Number.isFinite(n) ? n : def; }
  function normalizeVariantId(raw) {
    if (!raw) return null;
    if (/^\d+$/.test(String(raw).trim())) return Number(raw);
    const m = String(raw).match(/\d+/);
    return m ? Number(m[0]) : null;
  }
  function clampByMinMax(input, value) {
    let v = toInt(value, 0);
    if (input?.hasAttribute('min')) v = Math.max(v, toInt(input.getAttribute('min'), 0));
    if (input?.hasAttribute('max')) {
      const maxAttr = input.getAttribute('max');
      const max = toInt(maxAttr, 0);
      if (max > 0) v = Math.min(v, max);
    }
    return v;
  }
  function normalizeColorStr(str) {
    if (!str) return '';
    return String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();
  }
  function extractColorFromKey(key) {
    if (!key) return '';
    const trimmed = String(key).trim();
    const m = trimmed.match(/^\s*\d+\s+(.*)$/); // elimina prefijo numérico tipo "1 NEGRO"
    return normalizeColorStr(m ? m[1] : trimmed);
  }
  function parseVariantMapFrom(el) {
    const src = el?.dataset?.variantMap || el?.getAttribute?.('data-variant-map');
    if (!src) return null;
    try { return JSON.parse(src); }
    catch { try { return JSON.parse(src.replace(/&quot;/g, '"')); } catch { return null; } }
  }
  function findSelectedColorForInput(inputEl) {
    // 1) Si el wrapper ya tiene un data-current-color “rico”, úsalo.
    const table = inputEl.closest('.mox-talla-table');

    const canon = table?.dataset?.matchedColorKey || table?.dataset?.currentColor;
    if (canon && /\S/.test(canon)) return canon;  // ← usa primero la clave exacta

    // 2) Radio seleccionado: intentar atributos más expresivos que value
    const radio = document.querySelector('input[type="radio"][name="Color"]:checked');
    if (radio) {
      // Candidatos en orden de preferencia
      const candidates = [
        radio.getAttribute('data-option-value'),
        radio.getAttribute('data-color'),
        radio.getAttribute('aria-label'),
        radio.getAttribute('title'),
        // Texto del label asociado
        (document.querySelector(`label[for="${radio.id}"]`)?.textContent || '').trim(),
        // Fallback final: value
        radio.value
      ].filter(Boolean);

      for (const c of candidates) {
        if (/\S/.test(c)) return c;
      }
    }

    return '';
  }


  // function resolveEntryByColor(mapObj, selectedColorRaw) {
  //   if (!mapObj) return null;
  //   const selectedColor = normalizeColorStr(selectedColorRaw || '');
  //   if (!selectedColor) return null;

  //   const keys = Object.keys(mapObj);
  //   if (!keys.length) return null;

  //   // “51 VERDE” → bare: “VERDE”, code: “51”
  //   const bare = selectedColor.replace(/^\s*\d+\s+/, '');
  //   const codeMatch = selectedColor.match(/^\s*(\d+)\b/);
  //   const code = codeMatch ? codeMatch[1] : null;

  //   // A) Igualdad exacta por nombre “limpio”
  //   for (const k of keys) {
  //     if (extractColorFromKey(k) === selectedColor) return mapObj[k];
  //   }
  //   // B) Igualdad exacta por “bare”
  //   if (bare) {
  //     for (const k of keys) {
  //       if (extractColorFromKey(k) === bare) return mapObj[k];
  //     }
  //   }
  //   // C) Prefijo por código (51 → "51" o "51 <nombre>")
  //   if (code) {
  //     for (const k of keys) {
  //       const nk = String(k).trim().toUpperCase();
  //       if (nk === code || nk.startsWith(code + ' ')) return mapObj[k];
  //     }
  //   }
  //   // D) Igualdad por “bare” en ambos lados
  //   if (bare) {
  //     for (const k of keys) {
  //       const nkBare = extractColorFromKey(k).replace(/^\s*\d+\s+/, '');
  //       if (nkBare === bare) return mapObj[k];
  //     }
  //   }
  //   // Sin “contains” para evitar caer en claves numéricas puras (“1”, “2”…)
  //   return null;
  // }

  function resolveEntryByColor(mapObj, selectedColorRaw) {
    if (!mapObj) return null;
    const selectedColor = normalizeColorStr(selectedColorRaw || '');
    if (!selectedColor) return null;

    const keys = Object.keys(mapObj);
    if (!keys.length) return null;

    // “34 CORAL” → bare: “CORAL”, code: “34”
    const bare = selectedColor.replace(/^\s*\d+\s+/, '');
    const codeMatch = selectedColor.match(/^\s*(\d+)\b/);
    const code = codeMatch ? codeMatch[1] : null;

    // 1) match EXACTO por clave completa (incluye número)
    for (const k of keys) {
      if (normalizeColorStr(k) === selectedColor) return mapObj[k];
    }
    // 2) match por prefijo numérico (34 → "34" o "34 …")
    if (code) {
      for (const k of keys) {
        const nk = String(k).trim().toUpperCase();
        if (nk === code || nk.startsWith(code + ' ')) return mapObj[k];
      }
    }
    // 3) match por bare (último recurso)
    if (bare) {
      for (const k of keys) {
        if (extractColorFromKey(k) === bare) return mapObj[k];
      }
    }
    return null;
  }

  function resolveEntryStable(mapObj, selectedColorRaw, tableEl) {
    const sel = normalizeColorStr(selectedColorRaw || '');
    if (!sel || !mapObj) return null;

    // Si ya resolvimos antes para este mismo color, respetarlo
    const lastKey = tableEl?.dataset?.matchedColorKey || '';
    if (lastKey && normalizeColorStr(lastKey) === sel && mapObj[lastKey]) {
      return mapObj[lastKey];
    }

    const entry = resolveEntryByColor(mapObj, selectedColorRaw);
    if (entry && tableEl) {
      // Encuentra la clave real usada (mismo objeto por referencia)
      const foundKey = Object.keys(mapObj).find(k => mapObj[k] === entry) || '';

      if (foundKey) {
        tableEl.dataset.matchedColorKey = foundKey;     // clave exacta del mapa (p. ej. "34 CORAL")
        tableEl.dataset.currentColor = foundKey;      // IMPORTANTÍSIMO: dejamos el color “canónico”
      }

    }
    return entry;
  }

  function getVariantEntryForRow(inputEl) {
    const row = inputEl.closest('.mox-talla-table__row') || document;
    const mapObj =
      parseVariantMapFrom(inputEl) ||
      parseVariantMapFrom(row.querySelector('.mox-talla-stock'));
    if (!mapObj) return null;

    const selectedColor = findSelectedColorForInput(inputEl);
    const table = inputEl.closest('.mox-talla-table');
    return resolveEntryStable(mapObj, selectedColor, table);
  }

  function normalizeShopifyPrice(raw) {
    const n = Number(raw);
    if (!Number.isFinite(n)) return 0;
    return (n > 9999) ? Math.round(n / 100) : Math.round(n);
  }

  // ===================== Estado / Draft =====================
  const __waiters = new Set();
  let __paintArmedUntil = 0;
  let __paintTokenSeq = 1;
  let __lastPaintedToken = 0;
  let __currentActiveToken = 0;
  const __variantStockCache = new Map();
  let __lastQuantitiesMap = null;

  // ---- SOLO para controlar apertura del carrito sin cambiar la lógica existente ----
  let __openCartArmedUntil = 0;
  function armOpenCart(ms = 4000) { __openCartArmedUntil = Date.now() + ms; }
  function shouldOpenCart() { return Date.now() < __openCartArmedUntil; }

  function armPaintWindow(ms = 15000) {
    __paintArmedUntil = Date.now() + ms;
    console.log('[mox-talla] paint window ARMADA por', ms, 'ms (hasta', new Date(__paintArmedUntil).toISOString(), ')');
  }
  function isPaintArmed() { return Date.now() < __paintArmedUntil; }
  function disarmPaintWindow() { __paintArmedUntil = 0; }

  function getBaseStockForVariant(row, variantIdNum) {
    if (__variantStockCache.has(variantIdNum)) return __variantStockCache.get(variantIdNum);
    const input = row.querySelector('.mox-talla-input');
    const stockSpan = row.querySelector('.mox-talla-stock');

    let mapObj = parseVariantMapFrom(input) || parseVariantMapFrom(stockSpan);
    let base = null;

    if (mapObj && typeof mapObj === 'object') {
      for (const key of Object.keys(mapObj)) {
        const entry = mapObj[key];
        const idNum = Number(String(entry?.id || '').match(/\d+/)?.[0] || NaN);
        if (Number.isFinite(idNum) && idNum === variantIdNum) { base = Number(entry?.stock || 0); break; }
      }
    }
    if (base == null) base = toInt(stockSpan?.textContent, 0);

    __variantStockCache.set(variantIdNum, base);
    console.log('[mox-talla] baseStock cache set:', variantIdNum, '→', base);
    return base;
  }

  // ===================== PRECIOS =====================
  function getRowUnitPrice(inputEl) {
    const entry = getVariantEntryForRow(inputEl);
    if (entry?.price != null) {
      const unit = normalizeShopifyPrice(entry.price);
      console.log('[mox-talla] getRowUnitPrice(map) =', unit, 'para vid?', entry.id);
      return unit;
    }
    const dp = toNum(inputEl.dataset.price, 0);
    console.log('[mox-talla] getRowUnitPrice(fallback data-price)=', dp);
    return Math.round(dp);
  }

  // ===================== Totales =====================
  function recomputeTotals(origin = 'manual') {
    let sumInputs = 0, sumStocks = 0, totalPrice = 0;

    document.querySelectorAll('.mox-talla-table__row').forEach(row => {
      const input = row.querySelector('.mox-talla-input');
      const stockSpan = row.querySelector('.mox-talla-stock');

      if (input) {
        const q = toInt(input.value, 0);
        sumInputs += q;
        const unit = getRowUnitPrice(input);
        totalPrice += q * unit;
      }
      if (stockSpan) sumStocks += toInt(stockSpan.textContent, 0);
    });

    const uds = document.querySelector('.mox-talla-uds');
    if (uds) uds.textContent = String(sumInputs);

    const stockMirror = document.querySelector('.mox-stock-mirror');
    if (stockMirror) stockMirror.textContent = String(sumStocks);

    const totalSpan = document.querySelector('.mox-talla-total');
    if (totalSpan) totalSpan.textContent = fmtCOP.format(Math.round(totalPrice));

    console.log(`[mox-talla] recomputeTotals(${origin}): uds=${sumInputs} | stock=${sumStocks} | total=${totalPrice}`);
  }

  // ===================== Pintar UNA FILA desde mapa (Liquid - qty draft) =====================
  function paintRowStockFromMap(inputEl, mapQuantities, logTag = 'row-paint') {
    if (!inputEl) return;
    const row = inputEl.closest('.mox-talla-table__row');
    const stockCell = row?.querySelector('.mox-talla-stock');
    if (!row || !stockCell) return;

    const vid = normalizeVariantId(inputEl.dataset.variantId);
    if (vid == null) return;

    const baseStock = getBaseStockForVariant(row, vid);
    const qtyInDraft = mapQuantities instanceof Map ? toInt(mapQuantities.get(vid) ?? 0, 0) : 0;
    const next = Math.max(0, baseStock - qtyInDraft);

    const currentCellValue = toInt(stockCell.textContent, 0);
    stockCell.textContent = String(next);

    console.log(`[mox-talla] ${logTag}: vid=${vid} | base=${baseStock} | qtyInDraft=${qtyInDraft} | curr=${currentCellValue} → next=${next}`);
  }

  // ===================== Pintar TODAS las filas desde borrador =====================
  function paintStockCellsFromDraft(mapQuantities) {
    console.log('[mox-talla] paintStockCellsFromDraft: map size=', mapQuantities.size);
    const rows = document.querySelectorAll('.mox-talla-table__row');
    rows.forEach(row => paintRowStockFromMap(row.querySelector('.mox-talla-input'), mapQuantities, 'table-paint'));
    recomputeTotals('after-paint-draft');
  }

  // ===================== Color change → stock + inputs + price =====================
  function paintAndFillOnColorChange(selectedColorRaw) {
    const selectedColor = normalizeColorStr(selectedColorRaw);
    console.log('[mox-talla] paintAndFillOnColorChange →', selectedColorRaw, '→', selectedColor);

    document.querySelectorAll('.mox-talla-table__row').forEach(row => {
      const input = row.querySelector('.mox-talla-input');
      const stockSpan = row.querySelector('.mox-talla-stock');
      if (!input || !stockSpan) return;

      const mapObj = parseVariantMapFrom(input) || parseVariantMapFrom(stockSpan);
      if (!mapObj) return;

      const table = row.closest('.mox-talla-table');
      const entry = resolveEntryStable(mapObj, selectedColor, table);

      // Si NO hay variant para esa talla en el color actual → dejar fila coherente y deshabilitar
      if (!entry) {
        input.dataset.variantId = '';
        input.setAttribute('data-variant-id', '');
        // conserva el data-price existente si lo había; si no, 0
        input.dataset.price = input.dataset.price || '0';
        input.setAttribute('data-price', input.dataset.price);

        stockSpan.textContent = '0';
        input.value = '0';
        input.dataset.prevValue = '0';
        input.setAttribute('data-prev-value', '0');

        input.disabled = true;
        input.title = 'Sin disponibilidad para este color';
        return;
      }

      // Hay entry → habilitar y actualizar todo
      input.disabled = false;
      input.title = '';

      const vid = normalizeVariantId(entry.id);
      const baseStock = toInt(entry.stock, 0);
      const unitPrice = normalizeShopifyPrice(entry.price);

      // Reflejar dataset/atributos
      input.dataset.variantId = String(vid);
      input.setAttribute('data-variant-id', String(vid));
      input.dataset.price = String(unitPrice);
      input.setAttribute('data-price', String(unitPrice));

      // Cachear base stock por variant
      __variantStockCache.set(vid, baseStock);

      // Restar cantidades ya en borrador si corresponde
      let qtyInDraft = 0;
      if (__lastQuantitiesMap instanceof Map) {
        qtyInDraft = toInt(__lastQuantitiesMap.get(vid) ?? 0, 0);
      }
      const nextStock = Math.max(0, baseStock - (SUBTRACT_DRAFT_ON_COLOR_CHANGE ? qtyInDraft : 0));
      stockSpan.textContent = String(nextStock);

      // Prefill con la qty del draft para ese variant (sin forzar a >0)
      const clampedQty = clampByMinMax(input, qtyInDraft);
      const prevBefore = toInt(input.value, 0);
      input.value = String(clampedQty);
      input.dataset.prevValue = String(clampedQty);
      input.setAttribute('data-prev-value', String(clampedQty));

      console.log('[mox-talla] row color change → vid=', vid,
        '| baseStock=', baseStock, '| qtyInDraft(last)=', qtyInDraft,
        '| unitPrice=', unitPrice, '| stockNext=', nextStock,
        '| input:', prevBefore, '→', clampedQty);
    });

    recomputeTotals('after-color-change-fill');
  }


  // ===================== Inputs desde borrador (solo en load) =====================
  // Ahora resolvemos el variantId según el color ACTUAL de cada fila (no el que venga en data-variant-id)
  function fillInputsFromDraft(mapQuantities) {
    console.log('[mox-talla] fillInputsFromDraft: map size=', mapQuantities.size);
    const rows = document.querySelectorAll('.mox-talla-table__row');
    rows.forEach(row => {
      const input = row.querySelector('.mox-talla-input');
      if (!input) return;

      const entry = getVariantEntryForRow(input); // <-- usa color actual
      const vid = normalizeVariantId(entry?.id ?? input.dataset.variantId);
      if (vid == null) return;

      const q = mapQuantities.has(vid) ? toInt(mapQuantities.get(vid), 0) : 0;
      const clamped = clampByMinMax(input, q);

      // fija valor + atributos para mantener sincronía
      input.value = String(clamped);
      input.dataset.prevValue = String(clamped);
      input.setAttribute('data-prev-value', String(clamped));
      input.dataset.variantId = String(vid);
      input.setAttribute('data-variant-id', String(vid));

      console.log('[mox-talla] input vid=', vid, '→ set value=', clamped);
    });

    recomputeTotals('after-fill-inputs');
  }

  function payloadToQuantitiesMap(json, sourceTag = 'unknown') {
    const map = new Map();
    const nodesA = json?.draftOrder?.lineItems?.nodes;
    const nodesB = json?.lineItems?.nodes;

    console.log('[mox-talla] payload source=', sourceTag, 'keys=', Object.keys(json || {}));

    if (Array.isArray(nodesA)) {
      console.log('[mox-talla] draftOrder.lineItems.nodes length=', nodesA.length);
      nodesA.forEach(li => {
        const vid = normalizeVariantId(li?.variant?.id);
        const qty = toInt(li?.quantity, 0);
        if (vid != null) map.set(vid, qty);
      });
    }
    if (Array.isArray(nodesB)) {
      console.log('[mox-talla] lineItems.nodes length=', nodesB.length);
      nodesB.forEach(li => {
        const vid = normalizeVariantId(li?.variant?.id);
        const qty = toInt(li?.quantity, 0);
        if (vid != null) map.set(vid, qty);
      });
    }

    if (map.size === 0) console.warn('[mox-talla] ❗ Map vacío (no hay quantities) en', sourceTag);
    else console.log('[mox-talla] ✅ quantities map size=', map.size, 'source=', sourceTag);
    return map;
  }

  function resolveWaitersWith(map, reasonTag = '') {
    let resolvedCount = 0;
    __waiters.forEach(({ resolve, done }) => { if (!done.resolved) { resolve(map); done.resolved = true; resolvedCount++; } });
    __waiters.forEach(w => { if (w.done.resolved) __waiters.delete(w); });
    console.log('[mox-talla] resolveWaitersWith: resolved', resolvedCount, 'waiters. reason=', reasonTag);
  }

  function waitForLatestDraftQuantities(timeoutMs = 15000) {
    return new Promise((resolve) => {
      const to = setTimeout(() => {
        console.warn('[mox-talla] ⏱ timeout esperando mapa de cantidades (latest-by-customer)');
        resolve(new Map());
        __waiters.forEach(w => { if (w.to === to) __waiters.delete(w); });
      }, timeoutMs);
      const waiter = { resolve, to, done: { resolved: false } };
      __waiters.add(waiter);
      console.log('[mox-talla] waitForLatestDraftQuantities: waiter agregado. timeout=', timeoutMs, 'ms. totalWaiters=', __waiters.size);
    });
  }

  // ===================== Abrir carrito tras draft cargado (CONDICIONAL) =====================
  let __lastCartOpenTs = 0;
  function tryOpenCartDrawer(reason = 'unknown') {
    const now = Date.now();
    if (now - __lastCartOpenTs < 1200) {
      console.log('[mox-talla] carrito: throttle, ya se abrió hace', now - __lastCartOpenTs, 'ms');
      return;
    }
    __lastCartOpenTs = now;
    console.log('[mox-talla] intentando abrir carrito. reason =', reason);

    try {
      if (window.HDT?.Drawer?.open) { window.HDT.Drawer.open('cart'); console.log('[mox-talla] carrito abierto via HDT.Drawer.open("cart")'); return; }
      if (window.HDT?.Theme?.CartDrawer?.open) { window.HDT.Theme.CartDrawer.open(); console.log('[mox-talla] carrito abierto via HDT.Theme.CartDrawer.open()'); return; }
    } catch (e) { console.warn('[mox-talla] drawer API error', e); }

    const triggers = [
      '[data-open-cart]', '[data-cart-open]', '[data-drawer-toggle="cart"]', '[data-action="open-cart"]',
      '.hdt-open-cart', '.hdt-mini-cart-toggle', '.js-mini-cart-toggle', 'a[href="/cart"]'
    ];
    for (const sel of triggers) {
      const btn = document.querySelector(sel);
      if (btn) { btn.dispatchEvent(new Event('click', { bubbles: true })); console.log('[mox-talla] carrito abierto via click', sel); return; }
    }
    const drawers = ['#hdt-mini-cart', '.hdt-mini-cart', '#cart-drawer', '.cart-drawer'];
    for (const sel of drawers) {
      const el = document.querySelector(sel);
      if (el) { el.classList.add('is-open', 'open'); el.setAttribute('open', ''); console.log('[mox-talla] carrito abierto (fallback clases) en', sel); return; }
    }
    console.warn('[mox-talla] no se encontró cómo abrir el carrito.');
  }

  // window.addEventListener('mox:draft:loaded', () => {
  //   console.log('[mox-talla] evt= mox:draft:loaded');
  //   if (!shouldOpenCart()) {
  //     console.log('[mox-talla] abrir carrito OMITIDO (no armado)');
  //     return;
  //   }
  //   tryOpenCartDrawer('event:mox:draft:loaded');
  //   __openCartArmedUntil = 0;
  // });

  // ===================== Eventos draft (quantities & paint) =====================
  ;['mox:draft:latest', 'mox:draft:updated', 'mox:draft:refreshed'].forEach(evtName => {
    window.addEventListener(evtName, (ev) => {
      console.log('[mox-talla] evt=', evtName, 'detail=', ev?.detail);
      const data = ev?.detail?.draftOrder ? ev.detail : (ev?.detail || {});
      const map = payloadToQuantitiesMap(data, `event:${evtName}`);

      __lastQuantitiesMap = map;

      const shouldPaintStock = (__waiters.size > 0) || isPaintArmed();
      console.log('[mox-talla] shouldPaintStock?', shouldPaintStock, '| waiters=', __waiters.size, '| armed=', isPaintArmed());

      if (map.size > 0) {
        if (shouldPaintStock) {
          paintStockCellsFromDraft(map);
          __lastPaintedToken = __currentActiveToken || 0;
        } else {
          console.log('[mox-talla] (LOAD) rellenando inputs con quantities; STOCK se mantiene de Liquid.');
          fillInputsFromDraft(map);
        }
        resolveWaitersWith(map, `event:${evtName}`);
      }
    });
  });

  // ===================== Patch fetch: SOLO latest-by-customer =====================
  if (!window.__moxFetchPatchedLatestOnly) {
    window.__moxFetchPatchedLatestOnly = true;
    const origFetch = window.fetch.bind(window);
    window.fetch = async function patchedFetch(input, init) {
      const res = await origFetch(input, init);
      try {
        const url = (typeof input === 'string') ? input : (input?.url || '');
        const lower = String(url).toLowerCase();
        console.log('[mox-talla] fetch:', lower, 'status=', res.status);
        if (lower.includes('/draft-orders/latest-by-customer/')) {
          res.clone().json().then(json => {
            console.log('[mox-talla] ← latest-by-customer JSON recibido');
            window.dispatchEvent(new CustomEvent('mox:draft:latest', { detail: json }));
          }).catch((e) => console.warn('[mox-talla] latest-by-customer parse error', e));
        }
      } catch (e) { console.warn('[mox-talla] fetch patch error', e); }
      return res;
    };
  }

  // ===================== Totales en vivo =====================
  document.addEventListener('input', function (ev) {
    const el = ev.target;
    if (!el?.classList?.contains('mox-talla-input')) return;
    const unit = getRowUnitPrice(el);
    el.dataset.price = String(unit);
    el.setAttribute('data-price', String(unit));
    recomputeTotals('input-change');
  }, true);

  document.addEventListener('focusin', function (ev) {

    const el = ev.target;
    if (!el?.classList?.contains('mox-talla-input')) return;

    // Clear "0" on focus
    if (el.value === '0') {
      el.value = '';
    }

    // 🔒 Si no hay usuario logueado: abrir modal de login y SALIR del handler.
    if (!window.MOX_CUSTOMER_ID) {
      return;
    }

    const v = clampByMinMax(el, el.value);
    const prevForNext = (ADDITIVE_INPUT_MODE ? 0 : v);
    el.dataset.prevValue = String(prevForNext);
    el.setAttribute('data-prev-value', String(prevForNext));

    console.log('[mox-talla] focusin: prevValue=', prevForNext);
  }, true);

  // ===================== Blur → addItem + actualizar stock (Liquid - qty última respuesta) =====================
  document.addEventListener('blur', async function (ev) {
    const el = ev.target;
    if (!el?.classList?.contains('mox-talla-input')) return;

    // Reset empty to "0" on blur
    if (el.value.trim() === '') {
      el.value = '0';
    }

    // 🔒 Si no hay usuario logueado: abrir modal de login y SALIR.
    if (!window.MOX_CUSTOMER_ID) {
      if (!isLoginModalOpen()) {
        try { window.openAuthModal?.('login', el); } catch (e) { console.warn('auth modal error', e); }
      }
      return;
    }

    const currRaw = el.value;
    const curr = clampByMinMax(el, currRaw);
    if (String(curr) !== String(currRaw)) el.value = String(curr);

    const prev = toInt(el.dataset.prevValue ?? el.getAttribute('value') ?? 0, 0);
    const delta = ADDITIVE_INPUT_MODE ? curr : (curr - prev);
    console.log('[mox-talla] blur: prev=', prev, 'curr=', curr, 'delta=', delta);

    if (delta === 0) { recomputeTotals('after-blur-nochange'); return; }

    // Resolver SIEMPRE por color actual de la fila
    const entry = getVariantEntryForRow(el);
    const variantId = normalizeVariantId(entry?.id ?? el.dataset.variantId);
    if (!variantId) {
      console.warn('[mox-talla] blur: variantId no resuelto');
      el.dataset.prevValue = String(curr);
      el.setAttribute('data-prev-value', String(curr));
      recomputeTotals('after-blur-invalid');
      return;
    }

    // sincroniza atributos antes de enviar
    el.dataset.variantId = String(variantId);
    el.setAttribute('data-variant-id', String(variantId));
    el.dataset.price = String(getRowUnitPrice(el));
    el.setAttribute('data-price', String(getRowUnitPrice(el)));

    if (!window.MOX_DRAFT || typeof window.MOX_DRAFT.addItem !== 'function') {
      console.warn('[mox-talla] blur: MOX_DRAFT.addItem no disponible');
      el.dataset.prevValue = String(curr);
      el.setAttribute('data-prev-value', String(curr));
      recomputeTotals('after-blur-no-mox');
      return;
    }

    const myToken = ++__paintTokenSeq;
    __currentActiveToken = myToken;
    __lastPaintedToken = 0;

    (function arm(ms = 15000) { __paintArmedUntil = Date.now() + ms; console.log('[mox-talla] paint window ARMADA por', ms); })();

    const waitMap = new Promise((resolve) => {
      const to = setTimeout(() => { console.warn('[mox-talla] ⏱ timeout latest-by-customer'); resolve(new Map()); }, 15000);
      const waiter = { resolve, to, done: { resolved: false } };
      __waiters.add(waiter);
    });

    const oldDisabled = el.disabled;
    el.disabled = true;

    try {
      console.log('[mox-talla] calling MOX_DRAFT.addItem(', variantId, ',', delta, ')');

      await window.MOX_DRAFT.addItemInput({ variantId, quantity: delta });


      console.log('[mox-talla] addItem OK, esperando respuesta de latest-by-customer…');

      const mapQuantities = await waitMap;
      const effectiveMap = (mapQuantities && mapQuantities.size > 0)
        ? mapQuantities
        : (__lastQuantitiesMap instanceof Map ? __lastQuantitiesMap : new Map());

      paintRowStockFromMap(el, effectiveMap, mapQuantities.size ? 'row-paint(new-map)' : 'row-paint(last-known)');

      if (mapQuantities.size > 0) {
        if (__lastPaintedToken !== myToken) {
          paintStockCellsFromDraft(mapQuantities);
        }
        __lastQuantitiesMap = mapQuantities;
      }

      el.dataset.prevValue = String(curr);
      el.setAttribute('data-prev-value', String(curr));
      recomputeTotals('after-blur');
    } catch (err) {
      console.error('[mox-talla] Error en addItem/espera', err);
      el.dataset.prevValue = String(toInt(el.value, prev));
      el.setAttribute('data-prev-value', String(toInt(el.value, prev)));
      recomputeTotals('after-blur-error');
    } finally {
      el.disabled = oldDisabled;
      __paintArmedUntil = 0;
      if (__currentActiveToken === myToken) __currentActiveToken = 0;
    }
  }, true);

  // ===================== Cambio de color (robusto) =====================
  document.addEventListener('change', (ev) => {
    const t = ev.target;
    if (!t?.matches?.('input[type="radio"][name="Color"]')) return;

    // Extraer un valor de color “rico” del control, no usar solo .value
    const candidates = [
      t.getAttribute('data-option-value'),
      t.getAttribute('data-color'),
      t.getAttribute('aria-label'),
      t.getAttribute('title'),
      (document.querySelector(`label[for="${t.id}"]`)?.textContent || '').trim(),
      t.value
    ].filter(Boolean);

    let color = '';
    for (const c of candidates) { if (/\S/.test(c)) { color = c; break; } }

    // Guardamos lo que vino del radio por ahora; paintAndFill… lo “snapeará” a la clave exacta
    document.querySelectorAll('.mox-talla-table').forEach(tbl => { tbl.dataset.currentColor = color; });

    console.log('[mox-talla] color cambiado →', color);
    paintAndFillOnColorChange(color);
  }, true);


  // ===================== BOOT INICIAL =====================
  (function bootColorSyncOnLoad() {
    function checkedRadioColor() {
      return document.querySelector('input[type="radio"][name="Color"]:checked')?.value || '';
    }
    function currentColor() {
      // Priorizar SIEMPRE el radio seleccionado si existe
      const cr = checkedRadioColor();
      if (cr) return cr;
      const tbl = document.querySelector('.mox-talla-table');
      return (tbl?.dataset?.currentColor) || '';
    }
    function forceDatasetTo(color) {
      document.querySelectorAll('.mox-talla-table').forEach(tbl => { tbl.dataset.currentColor = color; });
    }
    function trySync() {
      const color = currentColor();
      const hasRows = document.querySelectorAll('.mox-talla-input').length > 0;
      const hasMaps = !!document.querySelector('.mox-talla-input[data-variant-map], .mox-talla-stock[data-variant-map]');
      if (color && hasRows && hasMaps) {
        // Asegura que el dataset del wrapper coincida con el radio
        forceDatasetTo(color);
        console.log('[mox-talla] boot sync → paintAndFillOnColorChange(', color, ')');
        paintAndFillOnColorChange(color);
        return true;
      }
      return false;
    }
    // intentos suaves por si la tabla o los maps aparecen tras hidratar
    let tries = 0;
    const maxTries = 30; // ~3s con 100ms
    const iv = setInterval(() => {
      tries++;
      if (trySync() || tries >= maxTries) clearInterval(iv);
    }, 100);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', trySync, { once: true });
      window.addEventListener('load', trySync, { once: true });
    } else {
      trySync();
      window.addEventListener('load', trySync, { once: true });
    }
  })();

  console.log('[mox-talla] listo (V9: sync duro de color con radio; setAttribute en variant/price/prev; fillInputsFromDraft por color actual)');

  // helper minimal para saber si la modal de login ya está abierta
  function isLoginModalOpen() {
    return !!document.querySelector(
      'hdt-modal#login-form-popup[open], hdt-modal[open].hdt-modal-customer, .hdt-modal.hdt-modal-customer[open], .hdt-modal.is-open'
    );
  }

})();















// SCRIPT PARA ESTADO DEL BOTON
(function () {
  // Snippet independiente: habilita/deshabilita .hdt-card-product__atc también en refresh
  if (window.__moxAtcToggleInit2) return;
  window.__moxAtcToggleInit2 = true;

  // Lee el total de unidades desde el DOM (prefiere .mox-talla-uds; si no existe, suma inputs)
  function getTotalUnits() {
    const udsEl = document.querySelector('.mox-talla-uds');
    if (udsEl) {
      const n = Number(String(udsEl.textContent).replace(/[^\d.-]/g, '')) || 0;
      return n;
    }
    let sum = 0;
    document.querySelectorAll('.mox-talla-input').forEach(inp => {
      const v = Number(String(inp.value).replace(/[^\d.-]/g, '')) || 0;
      sum += v;
    });
    return sum;
  }

  // Aplica el estado disabled al/los botón(es) de ATC
  function updateAtcDisabled() {
    const total = getTotalUnits();
    const shouldDisable = !(total > 0);
    document.querySelectorAll('.hdt-card-product__atc').forEach(btn => {
      try {
        if ('disabled' in btn) btn.disabled = shouldDisable;
        if (shouldDisable) {
          btn.setAttribute('aria-disabled', 'true');
          btn.classList.add('is-disabled');
        } else {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-disabled');
        }
      } catch (e) { /* no-op */ }
    });
  }

  // Observa cambios en el contador visual de uds
  function observeUds() {
    const udsEl = document.querySelector('.mox-talla-uds');
    if (!udsEl || !window.MutationObserver) return;
    const mo = new MutationObserver(updateAtcDisabled);
    mo.observe(udsEl, { childList: true, characterData: true, subtree: true });
  }

  // Observa cambios estructurales en la tabla (por si se rehidrata/reemplaza al cargar)
  function observeTable() {
    const tableWrap = document.querySelector('.mox-talla-table');
    if (!tableWrap || !window.MutationObserver) return;
    const mo = new MutationObserver(() => {
      // los cambios en inputs/stock pueden afectar unidades visibles
      updateAtcDisabled();
    });
    mo.observe(tableWrap, { childList: true, subtree: true });
  }

  // Reintentos suaves al cargar (por si los elementos aparecen después)
  function kickstartWithRetries() {
    let tries = 0;
    const maxTries = 50; // ~5s con 100ms
    const t = setInterval(() => {
      tries++;
      const hasUds = !!document.querySelector('.mox-talla-uds');
      const hasInputs = document.querySelectorAll('.mox-talla-input').length > 0;
      if (hasUds || hasInputs || tries >= maxTries) {
        clearInterval(t);
        observeUds();
        observeTable();
        updateAtcDisabled();
      }
    }, 100);
  }

  // Hooks pasivos a eventos existentes
  document.addEventListener('input', (ev) => {
    if (ev.target?.classList?.contains('mox-talla-input')) updateAtcDisabled();
  }, true);

  document.addEventListener('blur', (ev) => {
    if (ev.target?.classList?.contains('mox-talla-input')) {
      setTimeout(updateAtcDisabled, 0);
    }
  }, true);

  document.addEventListener('change', (ev) => {
    if (ev.target?.matches?.('input[type="radio"][name="Color"]')) {
      setTimeout(updateAtcDisabled, 0);
    }
  }, true);

  ['mox:draft:latest', 'mox:draft:updated', 'mox:draft:refreshed', 'mox:draft:loaded']
    .forEach(evt => window.addEventListener(evt, () => setTimeout(updateAtcDisabled, 0)));

  // Inicial en refresh/carga: DOMContentLoaded + load + pequeños retardos
  function boot() {
    kickstartWithRetries();
    // “rebotes” por si el DOM cambia después de hidratar
    setTimeout(updateAtcDisabled, 0);
    setTimeout(updateAtcDisabled, 300);
    setTimeout(updateAtcDisabled, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    window.addEventListener('load', boot);
  } else {
    boot();
    window.addEventListener('load', boot);
  }
})();









/* Mox · Qty Zero Notice — NO bloquea; muestra mensaje y saca el foco */
(function () {
  if (window.__moxZeroNotice) return;
  window.__moxZeroNotice = true;

  // Toast helper (usa #mox-toast si existe; si no, alert)
  function showToast(msg) {
    const host = document.getElementById('mox-toast');
    if (!host) { alert(msg); return; }
    const bubble = host.querySelector('.mox-toast__bubble');
    const text = host.querySelector('.mox-toast__text');
    if (!bubble || !text) { alert(msg); return; }

    text.textContent = msg;
    host.style.left = '50%';
    host.style.right = 'auto';
    host.style.transform = 'translateX(-50%)';
    host.style.top = '56px';
    bubble.style.opacity = '0';
    bubble.style.transition = 'opacity .15s ease, transform .15s ease';
    bubble.style.transform = 'translateY(-6px)';
    requestAnimationFrame(() => {
      bubble.style.opacity = '1';
      bubble.style.transform = 'translateY(0)';
    });
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => {
      bubble.style.opacity = '0';
      bubble.style.transform = 'translateY(-6px)';
    }, 2300);
  }

  // Evita spam de mensajes si el usuario mantiene presionado el 0
  let cooling = false;
  function notifyAndBlur(el) {
    if (!el) return;
    if (!cooling) {
      showToast('No es posible agregar cero cantidades');
      cooling = true;
      setTimeout(() => { cooling = false; }, 800);
    }
    // Saca el foco sin bloquear la escritura
    setTimeout(() => { try { el.blur(); } catch { } }, 0);
  }

  // Tecla "0" como primer dígito (campo vacío o todo seleccionado)
  document.addEventListener('keydown', function (ev) {
    const el = ev.target;
    if (!el?.classList?.contains('mox-talla-input')) return;

    const isZeroKey = (ev.key === '0' || ev.code === 'Digit0' || ev.code === 'Numpad0');
    if (!isZeroKey) return;

    const v = String(el.value || '');
    const selectionAll = el.selectionStart === 0 && el.selectionEnd === v.length;
    const emptyOrReplace = v === '' || selectionAll;

    // No prevenimos la tecla; solo notificamos y sacamos el foco
    if (emptyOrReplace) {
      notifyAndBlur(el);
    }
  }, true);

  // Pegado de "0" como contenido completo inicial
  document.addEventListener('paste', function (ev) {
    const el = ev.target;
    if (!el?.classList?.contains('mox-talla-input')) return;

    const clip = (ev.clipboardData || window.clipboardData)?.getData('text') || '';
    const digits = String(clip).replace(/[^\d]/g, '');
    const v = String(el.value || '');
    const selectionAll = el.selectionStart === 0 && el.selectionEnd === v.length;
    const emptyOrReplace = v === '' || selectionAll;

    // No bloqueamos el pegado; solo avisamos y blur si sería "0" inicial
    if (digits === '0' && emptyOrReplace) {
      notifyAndBlur(el);
    }
  }, true);

  // Por si llega a quedar en "0" (programático o autofill), avisar una vez y blur
  document.addEventListener('input', function (ev) {
    const el = ev.target;
    if (!el?.classList?.contains('mox-talla-input')) return;
    const digits = String(el.value || '').replace(/[^\d]/g, '');
    if (digits === '0') {
      notifyAndBlur(el);
    }
  }, true);
})();








(function () {
  if (window.__moxPdpOpenOnCreateDraft) return;
  window.__moxPdpOpenOnCreateDraft = true;

  // Abre el carrito una sola vez en la sesión
  function openCartOnce() {
    if (window.__openedAfterFirstATC_PDP) return;
    window.__openedAfterFirstATC_PDP = true;
    // 1) Evento (si tu shadow cart lo escucha)
    window.dispatchEvent(new CustomEvent('mox:shadow:open'));
    // 2) Fallback por click a triggers comunes del theme
    const t = document.querySelector(
      '[data-open-cart], [data-cart-open], [data-drawer-toggle="cart"], .hdt-open-cart, .hdt-mini-cart-toggle, .js-mini-cart-toggle'
    );
    try { if (t) t.click(); } catch (_) { }
  }

  // Valida tu JSON EXACTO: draftOrder.lineItems.edges[].node.quantity
  function responseHasQty(txt) {
    try {
      const j = JSON.parse(txt);
      const edges = j?.draftOrder?.lineItems?.edges || j?.data?.draftOrderCreate?.draftOrder?.lineItems?.edges || [];
      return edges.some(e => Number(e?.node?.quantity || 0) > 0);
    } catch { return false; }
  }

  // --- fetch() (si tu llamada usa fetch) ---
  const origFetch = window.fetch && window.fetch.bind(window);
  if (origFetch) {
    window.fetch = async function patchedFetch(input, init) {
      const res = await origFetch(input, init);
      try {
        const url = (typeof input === 'string') ? input : (input?.url || '');
        const method = String(init?.method || (typeof input !== 'string' ? input?.method : 'GET')).toUpperCase();
        if (method === 'POST' && /\/draft-orders(?:[\/?#]|$)/i.test(url)) {
          res.clone().text().then(txt => { if (responseHasQty(txt)) openCartOnce(); }).catch(() => { });
        }
      } catch { }
      return res;
    };
  }

  // --- XMLHttpRequest (si usas Axios/XHR) ---
  if (window.XMLHttpRequest && !window.__moxXhrOpenOnCreateDraft) {
    window.__moxXhrOpenOnCreateDraft = true;
    const XO = XMLHttpRequest.prototype.open;
    const XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__m = m; this.__u = u; return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (b) {
      this.addEventListener('load', () => {
        try {
          const m = String(this.__m || 'GET').toUpperCase();
          const u = String(this.__u || '');
          if (m === 'POST' && /\/draft-orders(?:[\/?#]|$)/i.test(u)) {
            if (responseHasQty(this.responseText)) openCartOnce();
          }
        } catch { }
      });
      return XS.apply(this, arguments);
    };
  }
})();
